_.mapObject = (obj, fn) => {
  var index = 0;
  var result = [];
  for (let key in obj) {
    result.push(fn(obj[key], key, index));
    index++;
  }
  return result;
};